import { render, staticRenderFns } from "./CandidateConnectors.vue?vue&type=template&id=31e5b219&scoped=true"
import script from "./CandidateConnectors.vue?vue&type=script&setup=true&lang=js"
export * from "./CandidateConnectors.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CandidateConnectors.vue?vue&type=style&index=0&id=31e5b219&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e5b219",
  null
  
)

export default component.exports